import Player from '@vimeo/player';

( function ( $ ) {
	$( function () {
		// Play video.
		$( '.featured-testimonials__card-play' ).on( 'click', function () {
			$( this ).hide();
			$( this )
				.parents( '.featured-testimonials__card-content' )
				.find( 'img, .featured-testimonials__card-title' )
				.hide();
			$( this )
				.parents( '.featured-testimonials__card-content' )
				.find( 'iframe' )
				.css( 'z-index', '1' );

			const iframe = $( this )
				.parents( '.featured-testimonials__card-content' )
				.find( 'iframe' );
			const player = new Player( iframe );
			player.play();
		} );
	} );
} )( jQuery );
